import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
	TRANSPARENT_COLOR,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame6 = (props: TQrFrameProps) => {
	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : 'white'
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: TRANSPARENT_COLOR

	const getTextY = (fontSize: number) => {
		const boxTop = 62
		const boxHeight = 18
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				id="frame"
				x={1}
				y={1}
				width={62}
				height={82}
				rx={3}
				fill={frameBackgroundColor}
				stroke={frameBackgroundColor}
				strokeWidth={2}
			/>
			<g id="frame">
				<path
					d="M6 10a4 4 0 0 1 4-4h44a4 4 0 0 1 4 4v44a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4z"
					fill={qrBackgroundColor}
					id="qr-background"
				/>
				{qrMarkup ? (
					<g
						dangerouslySetInnerHTML={{
							__html: flattenNestedSvg(qrMarkup, {
								x: 12,
								y: 12,
								width: 40,
								height: 40,
							}),
						}}
					/>
				) : (
					<MockQr x={12} y={12} />
				)}
			</g>
			<g id="text-container">
				<path
					d="M8 63h48a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V64a1 1 0 0 1 1-1"
					fill={frameColor}
				/>
				<path
					d="M8 63h48a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V64a1 1 0 0 1 1-1Z"
					stroke={frameColor}
					strokeWidth={2}
				/>
				<FrameText
					text={props.text}
					fontSize={props.fontSize}
					textColor={textColor}
					textY={getTextY(props.fontSize)}
					fontFamily={DEFAULT_FRAME_FONT}
				/>
			</g>
		</svg>
	)
}
